import { BLOCK_EXPLORER_TXN_ID_URL } from '../../../utils/config';

export const NftDetails = ({ reportData }) => {
  return (
    <div className="flex flex-col rounded-lg bg-[#17191C] p-4 sm:p-6 gap-4 sm:gap-6">
      <h3 className="font-normal text-xl md:text-2xl">NFT Proof</h3>
      <table className="w-full table-fixed file-table">
        <tbody className="w-full flex flex-col gap-1">
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Token Id:</th>
            <td className="font-normal text-core-grey-80 text-sm sm:text-base break-all">
              {reportData.TOKEN_ID}
            </td>
          </tr>
          {/* <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
            <th className="font-bold text-white">Index refrence:</th>
            <td className="">{reportData.TOKEN_ID_INDEX}</td>
          </tr> */}
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Link to NFT:</th>
            <td className="font-normal text-core-grey-80 text-sm sm:text-base">
              <a
                href={`${BLOCK_EXPLORER_TXN_ID_URL}/${reportData.TOKEN_TXPOW}`}
                target="_blank"
                className="text-orange cursor-pointer break-all hover:underline"
              >
                Minima explorer
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
